import { fromJS } from 'immutable';
const initialState = {
  languages: [],
  civilities: [],
  activities: [],
  financingtypes: [],
  financingsubtypes: [],
  cities: [],
  subjects: [],
  civility: '',
  lastName: '',
  firstName: '',
  compnyName: '',
  isClient: false,
  accountNumber: '',
  phoneNumber: '',
  address: '',
  postalCode: '',
  city: '',
  email: '',
  activity: '',
  financingType: '',
  financingSubType: '',
  projectDescription: '',
  creditAmount: '',
  duration: '',
  contribution: '',
  subject: '',
  message: '',
  type: '',
  loading: false,
};

export default function (state = fromJS(initialState), action) {
  switch (action.type) {
    case 'GET_DATA_SUCCESS':
      return state.withMutations((s) => {
        s.set('languages', action.payload.data.languages);
        s.set('cities', action.payload.data.cities);
        s.set('activities', action.payload.data.activities);
        s.set('financingtypes', action.payload.data.financingTypes);
        s.set('financingsubtypes', action.payload.data.financingSubTypes);
        s.set('subjects', action.payload.data.subjects);
        s.set('success', true);
      });
    default:
      return state;
  }
}
